if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const isBogo = this.dataset.isBogo === 'true';
        const isGiftEligible = this.dataset.isGiftEligible === 'true';

        if (isGiftEligible) {
          if (!formData.has('properties[Free Gift]')) {
            formData.append('properties[Free Gift]', '🎁 1 Free Gift included with this product');
          }
        } else {
          formData.delete('properties[Free Gift]');
        }

        // Buy 1 Get 1 Free: ONLY for Smart Watches (data-is-bogo="true")
        if (isBogo) {
          const currentQty = parseInt(formData.get('quantity')) || 1;
          formData.set('quantity', currentQty * 2);
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        const buyNowBtn = this.querySelector('.product-buy-now-bogo');
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (buyNowBtn) buyNowBtn.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (buyNowBtn) buyNowBtn.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );

  // Global click handler for product page "Buy it now" button with BOGO quantity doubling
  document.addEventListener('click', async function (e) {
    const buyNowBtn = e.target.closest('.product-buy-now-bogo');
    if (!buyNowBtn) return;
    e.preventDefault();
    if (buyNowBtn.hasAttribute('disabled') || buyNowBtn.getAttribute('aria-disabled') === 'true') return;

    const productForm = buyNowBtn.closest('product-form');
    const form = productForm ? productForm.querySelector('form') : buyNowBtn.closest('form');
    const variantInput = form ? form.querySelector('[name="id"]') : null;
    const variantId = variantInput ? variantInput.value : null;

    if (!variantId) {
      alert("Please select a variant.");
      return;
    }

    const sectionId = productForm ? productForm.dataset.sectionId : '';
    const qtyInput = (sectionId ? document.querySelector('#Quantity-' + sectionId) : null) || (form ? form.querySelector('[name="quantity"]') : null);
    const currentQty = parseInt(qtyInput ? qtyInput.value : 1) || 1;
    const bogoQty = currentQty * 2;

    const originalText = buyNowBtn.innerHTML;
    buyNowBtn.setAttribute('aria-disabled', 'true');
    buyNowBtn.classList.add('loading');
    buyNowBtn.innerHTML = '<span>Processing...</span>';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: bogoQty
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      window.location.href = '/checkout';
    } catch (err) {
      console.error(err);
      alert('Unable to proceed to checkout.');
      buyNowBtn.removeAttribute('aria-disabled');
      buyNowBtn.classList.remove('loading');
      buyNowBtn.innerHTML = originalText;
    }
  });
}

